//noinspection JSUnusedLocalSymbols
(function($) {
	'use strict';

	/**
	 * Loader and handler for SportEvents (based on the "sportal" data)
	 *
	 * @author Dave Talamona
	 * @class SCS.SportEvents
	 */

	// init namespace
	window.SCS = window.SCS || {};

	// private variables with library scope
	var events = [],
		isLoading = false,
		isLoaded = false,
		loadWasSuccessful = false,
		loadListeners = [],
		tvBackendDataStore = [];

	window.SCS.SportEvents = {
		/**
		 * This callback function is called after events are loaded
		 * @callback eventsLoadedCallback
		 * @param {bool} loadWasSuccessful
		 * @param {SCS.SportEvents.Event[]} events
		 */
		/**
		 * @param {String} url - Sportal data url
		 * @param {eventsLoadedCallback} callback - Callback is called after events are loaded
		 * @return void
		 */
		load: function (url, callback) {
			var jsonData;

			if (!isLoading && !isLoaded) {
				isLoading = true;

				// create callback for jsonP
				window.SCS.sportal = window.SCS.sportal || {};
				window.SCS.sportal.ticker = function (data) {
					jsonData = data;
				};

				// load jsonP (via "type=script" and not "jsonp" because of problems with the callback name config in jQuery)
				$.getScript(url)
					.done(function () {
						var singleEvent;

						loadWasSuccessful = true;

						// process and save data
						for (var i = 0; jsonData && jsonData.length && i < jsonData.length; i++) {
							singleEvent = new SCS.SportEvents.Event(jsonData[i]);

							// check if event is valid
							if (singleEvent.id && singleEvent.title && (singleEvent.hasStream || singleEvent.hasTicker)) {
								events.push(singleEvent);
							}
						}
					})
					.fail(function () {
						loadWasSuccessful = false;
					})
					.always(function () {
						debug.log("SCS.SportEvents > loaded", events);

						// call every registered load-listener
						for (var i = 0; i < loadListeners.length; i++) {
							loadListeners[i](loadWasSuccessful, [].concat(events));
						}

						isLoaded = true;
						isLoading = false;
					});
			}

			// handle callback
			if (typeof callback == 'function') {
				if (isLoaded) {
					callback(loadWasSuccessful, [].concat(events));
				} else {
					loadListeners.push(callback);
				}
			}
		},

		/**
		 * Filters all events by given options
		 * @param {Object} [options] - Configure the event-subset
		 * @param {Date} [options.maxDate] - All events further in the future then this date
		 * @param {bool} [options.includingFinished=false] - Include finished events (from the past)
		 * @param {bool} [options.ppvOnly=false] - Exclude Free-TV events
		 * @param {String} [options.sportid] - Only events with this sport-id
		 * @return {SCS.SportEvents.Event[]}
		 */
		getEvents: function (options) {
			var eventSubset = [].concat(events), // create a copy of the events array
				i;

			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				if (
					// remove events outside of a given timeframe (only if option "maxDate" is set)
					(
						options.maxDate &&
						options.maxDate < eventSubset[i].date
					) ||
					// remove finished events normally but NOT if option "includingFinished" is set to TRUE
					(
						options.includingFinished !== true &&
						eventSubset[i].finished
					) ||
					// remove Free-TV events
					(
						options.ppvOnly &&
						!eventSubset[i].ppvData
					) ||
					// remove events when other criteria does not match
					(
						options.sportid &&
						eventSubset[i].sportid != options.sportid
					)
				) {
					eventSubset.splice(i, 1);
					i--;
				}
			}

			debug.log("SCS.SportEvents > getEventSubset", options, eventSubset);

			return eventSubset;
		},

		/**
		 * @param {String} id
		 * @return {SCS.SportEvents.Event}
		 */
		findById: function (id) {
			for (var i = 0; i < events.length; i++) {
				if (events[i].id == id) {
					return events[i];
				}
			}

			return null;
		},

		/**
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {String} [options.todayLabel]
		 * @param {String} [options.tomorrowLabel]
		 * @return {Object[]} - Array of Objects containing the title and an array of events
		 */
		groupEventsByDate: function (eventSubset, options) {
			var datesObj = {},
				datesArr = [],
				datesTimestamps = [],
				timestamp,
				firstEvent,
				i;

			eventSubset = eventSubset || events;
			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				timestamp = window.SCS.utils.date.resetTime(eventSubset[i].startTime).getTime();

				if (!datesObj[timestamp]) {
					datesObj[timestamp] = [];
					datesTimestamps.push(timestamp);
				}

				datesObj[timestamp].push(eventSubset[i]);
			}

			datesTimestamps.sort();

			for (i = 0; i < datesTimestamps.length; i++) {
				timestamp = datesTimestamps[i];
				firstEvent = datesObj[timestamp][0];

				datesArr.push({
					title: (firstEvent.today && options.todayLabel ? options.todayLabel : (firstEvent.tomorrow && options.tomorrowLabel ? options.tomorrowLabel : window.SCS.utils.date.format(firstEvent.startTime))),
					events: datesObj[timestamp]
				});
			}

			return datesArr;
		},

		/**
		 * Create a list of all sport types found in the given events (ordered alphabetically by sport names)
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - Events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {String} [options.idPropertyName] - The name of the property for the sportTypes ID in the returned objects (defaults to 'id')
		 * @param {String} [options.namePropertyName] - The name of the property for the sportTypes NAME in the returned objects (defaults to 'name')
		 * @return {Object} - an Object containing
		 */
		getSportTypes: function (eventSubset, options) {
			var sportTypes = [],
				sportIds = {},
				sportNames = [],
				i, event, obj;

			eventSubset = eventSubset || [].concat(events); // create a copy of the events array if no subset parameter is passed
			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				event = eventSubset[i];

				if (!sportIds[event.sport]) {
					sportIds[event.sport] = event.sportid;
					sportNames.push(event.sport);
				}
			}

			sportNames.sort();

			for (i = 0; i < sportNames.length; i++) {
				obj = {};
				obj[options.idPropertyName || 'id'] = sportIds[sportNames[i]];
				obj[options.namePropertyName || 'name'] = sportNames[i];
				sportTypes.push(obj);
			}

			debug.log("SCS.SportEvents > getSportTypes", eventSubset, sportTypes);

			return sportTypes;
		},

		/**
		 * This callback function is called after events are loaded
		 * @callback eventsEnrichedCallback
		 * @param {SCS.SportEvents.Event[]} events
		 */
		/**
		 * Enrich event data with data loaded from the the TV backend
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - Events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {bool} [options.checkRentalStatus] - The name of the property for the sportTypes ID in the returned objects (defaults to 'id')
		 * @param {eventsEnrichedCallback} callback - Callback is called after events are altered/enriched
		 * @return void - Function directly alters the passed eventSubset
		 */
		enrichPpvEventsWithTvBackendData: function (eventSubset, options, callback) {
			$.when(

				// load event specific data from TV backend
				(function () {
					var defer = jQuery.Deferred(),
						idsToLoad = [],
						loadedData = [];

					// check for already loaded/cached values
					$(eventSubset).each(function () {
						var id = (this.ppvData || {}).identifier;

						// only proceed if it's a PPV event
						if (id) {
							if (tvBackendDataStore[id]) {
								loadedData.push(tvBackendDataStore[id]);
							} else {
								idsToLoad.push(id);
							}
						}
					});

					if (!idsToLoad.length) {
						defer.resolve(loadedData);
					} else {
						SCS.TV.getMultipleSportEventsById(idsToLoad, function (sportEvents) {
							$(sportEvents).each(function () {
								tvBackendDataStore[this.sportEventId] = this;
								loadedData.push(this);
							});

							defer.resolve(loadedData);
						});
					}

					return defer.promise();
				})(),

				// load purchases via snoopy from TV backend
				(function () {
					var defer = jQuery.Deferred(),
						broadcastIds = [];

					if (options.checkRentalStatus && SCS.snoopyInit) { // SCS.snoopyInit is available in Bluewin environment only
						SCS.snoopyInit(function () {
							if (!tvSessionService.currentSession.isActive) {
								defer.resolve(broadcastIds);
							} else {
								tvPurchasingService.Refresh(function () {
									if (tvPurchasingService.purchasingsListPPV && tvPurchasingService.purchasingsListPPV.length) {
										for (var i=0; tvPurchasingService.purchasingsListPPV[i]; i++) {
											broadcastIds.push(tvPurchasingService.purchasingsListPPV[i].subject);
										}
									}
									defer.resolve(broadcastIds);
								}, false);
							}
						});
					} else {
						defer.resolve(broadcastIds);
					}

					return defer.promise();
				})()

			).done(function (sportEvents, rentedBroadcastIds) {
				// iterate through each ppv event
				$(eventSubset).each(function () {
					var event = this,
						sportEvent = null, // instance of SCS.TV.SportEvent
						i = 0;

					// only proceed if it's a PPV event
					if (!event.ppvData) {
						return;
					}

					// find matching sport event
					for (i=0; sportEvents[i]; i++) {
						if (sportEvents[i].sportEventId == event.ppvData.identifier) {
							sportEvent = sportEvents[i];
						}
					}
					if (!sportEvent || !sportEvent.broadcasts.length) {
						event.hasError = true;
						return;
					}

					// get broadcast id and check rental status
					{
						var rentedBroadcast = null,
							setEventNotRented = function () {
								event.broadcast = sportEvent.getAutomaticSelectedBroadcast(event.language) || {};
								event.broadcastId = event.broadcast.broadcastId;
								event.isRented = false;

								if (!event.broadcastId) {
									event.hasError = true;
								}
							};

						if (options.checkRentalStatus) {
							// find rented broadcast
							for (i=0; sportEvent.broadcasts[i]; i++) {
								var broadcastIndex = jQuery.inArray(sportEvent.broadcasts[i].broadcastId, rentedBroadcastIds);

								if (broadcastIndex !== -1) {
									rentedBroadcast = sportEvent.broadcasts[i];
								}
							}

							// broadcast is rented -> apply found rented broadcast id to event
							if (rentedBroadcast) {
								event.broadcast = rentedBroadcast;
								event.broadcastId = rentedBroadcast.broadcastId;
								event.isRented = true;
							}

							// broadcast is not rented -> apply best guessed broadcast to event (matching language and cheapest price)
							else {
								setEventNotRented();
							}
						} else {
							// assume broadcast is not rented -> apply best guessed broadcast to event (matching language and cheapest price)
							setEventNotRented();
						}
					}
				});

				callback();
			});
		}
	};

})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.SportEvents.js
// module id = 93
// module chunks = 0